export default "__VITE_ASSET__851b2b67__"